import axios from '../utils/axios';
import {
  AmendmentOptions,
  ClinicalRecordHistory,
  ClinicalRecordVersionDetail,
  CommitAmendmentPayload,
  CommitAmendmentResult,
} from '../@types/clinicalRecordAmendment';

export class ClinicalRecordAmendmentsService {
  getOptions() {
    return axios.get<AmendmentOptions>('/clinical-record/amendments/options');
  }

  getHistory(clinicalRecordId: number) {
    return axios.get<ClinicalRecordHistory>(
      `/clinical-record/${clinicalRecordId}/history`,
    );
  }

  getVersion(clinicalRecordId: number, versionNumber: number) {
    return axios.get<ClinicalRecordVersionDetail>(
      `/clinical-record/${clinicalRecordId}/versions/${versionNumber}`,
    );
  }

  /** Logs that the user unlocked the signed record for amendment. */
  open(clinicalRecordId: number) {
    return axios.post<{ clinicalRecordId: number; currentVersion: number }>(
      `/clinical-record/${clinicalRecordId}/amendments/open`,
    );
  }

  commit(clinicalRecordId: number, payload: CommitAmendmentPayload) {
    return axios.post<CommitAmendmentResult>(
      `/clinical-record/${clinicalRecordId}/amendments`,
      payload,
    );
  }
}

/** Nest error bodies carry `message` as a string or a list of strings. */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const message = (error as { message?: string | string[] })?.message;
  if (Array.isArray(message)) return message.join('. ');
  if (typeof message === 'string' && message.trim()) return message;
  return fallback;
}
